import { useGetFrontRichiesteIdIntegrate } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { Flex, Typography } from 'antd';
import { IntegrationRows } from './IntegrationRows.tsx';

const { Text, Title } = Typography;

export interface ISubmissionSentTabIntegrationsProps {
  active?: boolean;
  title?: string;
  submission?: RichiestaDTO | undefined;
}

/**
 * Tab delle comunicazioni post invio di una richiesta richiesta.
 */
export function SubmissionSentTabIntegrations(
  props: ISubmissionSentTabIntegrationsProps,
) {
  const { active, submission } = props;
  const { data: integrations } = useGetFrontRichiesteIdIntegrate(
    submission!.id!,
  );

  if (!active) return null;

  return (
    <Flex vertical gap={32}>
      <IntegrationRows
        integrations={integrations}
        submissionId={submission?.id}
      />
    </Flex>
  );
}
